import { format, parseISO } from 'date-fns';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ImageComponent } from '@/components/Image';
import { Row, Table } from '@/components/Table';
import { nickEncrypting } from '@/helpers/common';
import { amountWithCurrencySymbol, CurrencyCode } from '@/helpers/currency';
import { mapLevels } from '@/helpers/jackpot';
import { useCommonStore } from '@/store';

import { ScJackpotTypeItem, ScWinnersTable } from './styled';

export const WinnersTable: FC = () => {
  const { t } = useTranslation('jackpot');
  const jackpotWinsList = useCommonStore.use.jackpotWinnersList();

  const normalizedDataForTable = useMemo(
    (): Row[] =>
      jackpotWinsList
        .sort(
          (a, b) =>
            parseISO(b.approvedAt).getTime() - parseISO(a.approvedAt).getTime()
        )
        .map(
          ({ amountCents, userName, jackpotLevelExternalCode, approvedAt }) => {
            const { icon, title } = mapLevels[jackpotLevelExternalCode];

            return {
              player: nickEncrypting(userName),
              jackpot: (
                <ScJackpotTypeItem>
                  {t(title)}
                  <ImageComponent
                    src={icon}
                    alt="jackpot type"
                    height={24}
                    width={24}
                  />
                </ScJackpotTypeItem>
              ),
              prize: amountWithCurrencySymbol(
                CurrencyCode.USD,
                amountCents / 100
              ),
              date: format(parseISO(approvedAt), 'dd.MM.yy'),
            };
          }
        ),
    [jackpotWinsList, t]
  );

  if (!jackpotWinsList.length) return null;

  return (
    <ScWinnersTable>
      <div className="title">{t('tableTitle')}</div>
      <Table
        columnWidth={[25, 25, 25, 25]}
        headersTransPath="jackpot:winnerTableHeaders"
        data={normalizedDataForTable}
        maxHeight={212}
      />
    </ScWinnersTable>
  );
};
